import { toast } from 'react-toastify';

const copyTextToClipboard = (text: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success('Copy success');
    })
    .catch(() => {
      toast.error('Copy error');
    });
};

export default copyTextToClipboard;
